import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.4-1.4 3.6 3.58L17.17 7l1.4 1.42L10 17z"
      fill="#118847"
    />
    <path d="M5 12l5 5 8.58-8.58L17.17 7 10 14.17 6.4 10.6 5 12z" fill="#fff" />
  </svg>
);
